export default __webpack_public_path__ + "static/media/case_study_quaker_cover.0b2ed96c.jpg";